import React from 'react'
import style from "./Spinner.module.css";

const Spinner = () => {
  return (
    <div className={style.spinner} />
  )
}

export default Spinner
